<template>
    <div>
        <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'">
            Réparation en autonomie
        </h1>
        <div class="border rounded-lg p-4 mt-2">
            <iframe
            id="tchat-iframe"
            class="w-full h-[450px]"
            :src="tchatUrl" 
            />
        </div>
    </div>
</template>

<script>
import apiService from '@/services/api.service'
import FormCardExtension from '@/extends/FormCardExtension'

export default {
    name: 'new-own-tchat',
    extends: FormCardExtension,

    data() {
        return {
            solved: false
        }
    },

    computed: {
        canDisplayReponses() {
            let unshowMessages = this.messages.find((msg) => msg.bot == 1 && (msg.show == false || msg.typing == true))
            return unshowMessages ? false : true
        },
        randomIdRefreshIframe() {
            return Math.floor((Math.random()*1000000)+1)
        },
        tchatUrl() {
            let tchatKey = this.$formTool.getFormData('tchat-key')
            if (!tchatKey) {
                var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
                var token = '';
                for (var i = 0; i < 20; i++) {
                    token += chars[Math.floor(Math.random() * chars.length)];
                }
                token = 'selfcare-' + token
                tchatKey = token
                this.$formTool.addFormData('tchat-key', tchatKey)
            }
            
            let url = 'https://distriadmin.savlog.net/widget/bdc/tchat?liaison_id=' + this.$formTool.getFormData('bdc').post[0].id + '&refresh=' + this.randomIdRefreshIframe + '&key=' + tchatKey
            // let url = 'http://localhost:8080/widget/bdc/tchat?liaison_id=' + this.$formTool.getFormData('bdc').post[0].id + '&refresh=' + this.randomIdRefreshIframe + '&key=' + tchatKey
            let onDemo = apiService.onDemo()
            if (onDemo) {
                url += '&preprod=1&domain_name=' + this.$companyTool.confFile().api_keyname
            }
            return url
        }
    },

    methods: {
        init() {
            this.loading = true
            
            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                this.nextBlock = this.$formTool.blockData(this.$options.name).next
                this.emitChange()
            }

            this.loading = false
        },

        end(callbackData) {
            let callback = {
                next: callbackData.next,
                messages: this.messages
            }
            this.$formTool.addFormData(this.$options.name, callback)
            this.nextBlock = callbackData.next
            this.selected = JSON.parse(JSON.stringify(callback))
        },

        async endForm(valid) {
            if (valid) {
                this.solved = true
                let response = await apiService.post('quizz_valid', {
                    id_conso: this.$crypto.decrypt(localStorage.getItem('client_id')),
                    id_app: this.$formTool.getFormData('device')[0].value.id
                })

                if (response.data.posts.post != 1) {
                    this.$toast.error('Une erreur est survenue')
                    return
                }

                this.end({next: 'end-form'})
            } else {
                // Online
                let response = await apiService.post('buyonline', {
                    id_app: this.$formTool.getFormData('device')[0].value.id
                })
                if (response.data.posts.post == 1) {
                    this.end({next: this.$formTool.blockData(this.$options.name).next.online})
                } else {
                    if (this.$formTool.getFormData('sign')) {
                        this.end({next: this.$formTool.blockData(this.$options.name).next.shop})
                    } else {
                        this.end({next: this.$formTool.blockData(this.$options.name).next.sign})
                    }
                }
            }
        },

        sendHistory(history) {
            this.$formTool.addFormData('tchat-history', history)
        }
    },

    mounted() {
        this.init()

        window.addEventListener("message", async (event) => {
            if (event.data && event.data.from && event.data.from == 'bdc-tchat') {
                switch (event.data.type) {
                    case 'loaded': // Component is loaded
                        break;
                    case 'reset': // Reset tchat
                        this.$emit('update', this.$options.name)
                        break;
                    case 'bot-message': // New bot message
                        break;
                    case 'user-response': // New user response
                        break;
                    case 'end-form': // End form (valid: true or false)
                        if (!event.data.meta.valid) {
                            this.sendHistory(event.data.meta.history)
                        }
                        this.endForm(event.data.meta.valid)
                        break;
                    case 'error': // On error
                        this.endForm(false)
                }
            }
        }, false);
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/tchat/NewOwnTchatCard.vue